import { render } from "./RegisterTermsConditions.vue?vue&type=template&id=0ef248fd&ts=true"
import script from "./RegisterTermsConditions.vue?vue&type=script&lang=ts"
export * from "./RegisterTermsConditions.vue?vue&type=script&lang=ts"

import exportComponent from "/Users/angeloquijano/Git/IWARI/iwari-vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__